import { ListViewReferredByCell } from 'components/molecules/ListViewReferredByCell';
import { ListViewCellText } from 'components/atoms/ListViewCellText';
import {
  getProspectCreatedDateFormatted,
  getProspectDisplayName,
} from 'helpers/listViewProspectDisplay';
import {
  getReferralMobileStatusPill,
  type ReferralSortField,
} from 'helpers/referralHelpers';
import { ListViewColumnDef } from 'types/listViewColumns';
import { Prospect } from 'types/prospect';

const REFERRAL_LIST_VIEW_COLUMNS: ListViewColumnDef<ReferralSortField>[] = [
  {
    id: 'name',
    label: 'Name',
    sortKey: 'name',
    renderCell: (prospect) => (
      <ListViewCellText>
        {getProspectDisplayName(prospect) || '-'}
      </ListViewCellText>
    ),
  },
  {
    id: 'created',
    label: 'Created',
    sortKey: 'created',
    renderCell: (prospect) => (
      <ListViewCellText>
        {getProspectCreatedDateFormatted(prospect)}
      </ListViewCellText>
    ),
  },
  {
    id: 'referredBy',
    label: 'Referred by',
    sortKey: 'referredBy',
    renderCell: (prospect) => (
      <ListViewReferredByCell referredBy={prospect.referredBy} />
    ),
  },
  {
    id: 'status',
    label: 'Status',
    sortKey: 'status',
    renderCell: (prospect) => (
      <ListViewCellText>
        {getReferralMobileStatusPill(prospect)}
      </ListViewCellText>
    ),
  },
];

const getReferralListViewMobileName = (prospect: Prospect) =>
  getProspectDisplayName(prospect) || '-';

const getReferralListViewMobileCreatedDate = (prospect: Prospect) =>
  getProspectCreatedDateFormatted(prospect);

export {
  REFERRAL_LIST_VIEW_COLUMNS,
  getReferralListViewMobileCreatedDate,
  getReferralListViewMobileName,
  getReferralMobileStatusPill,
};
